import API_GATEWAY from "@/services/config/main-axios";
import Router from "@/router";

export default {
  namespaced: true,
  state: {
    userInfo: {}
  },
  getters: {
    GET_USERINFO(state) {
      return state.userInfo;
    }
  },
  mutations: {
    MUTATE_USERINFO(state, userInfo) {
      state.userInfo = { ...userInfo };
    }
  },
  actions: {
    async ACTION_USERINFO({ commit }) {
      await API_GATEWAY.get("backoffice/userInfo")
        .then(response => {
          commit("MUTATE_USERINFO", response.data.data);
        })
        .catch(() => {
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          Router.replace({ name: "loginForm" });
        });
      // commit("MUTATE_USERINFO", userInfo);
    }
  }
};
